import React, { useState } from 'react';
import { Instagram, Link2, Unlink } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

function InstagramPanel({ igStatus, onStatusChange }) {
  const [igLoading, setIgLoading] = useState(false);

  const connectInstagram = async () => {
    setIgLoading(true);
    try {
      const resp = await axios.get(`${API_URL}/api/instagram/connect`);
      window.location.href = resp.data.auth_url;
    } catch {
      toast.error('Failed to initiate Instagram connection');
      setIgLoading(false);
    }
  };

  const disconnectInstagram = async () => {
    if (window.confirm('Disconnect Instagram? The live feed will stop displaying.')) {
      try {
        await axios.get(`${API_URL}/api/instagram/disconnect`);
        onStatusChange({ connected: false });
        toast.success('Instagram disconnected');
      } catch {
        toast.error('Failed to disconnect');
      }
    }
  };

  return (
    <div className="bg-white rounded-3xl p-6 md:p-8 shadow-[0_8px_32px_rgba(59,48,45,0.04)] border border-accent/30 mb-8" data-testid="ig-connection-section">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Instagram className="w-6 h-6 text-primary" />
          <div>
            <h3 className="font-playfair text-xl font-medium text-charcoal">Instagram Feed</h3>
            {igStatus?.connected ? (
              <p className="text-sm text-muted-text">Connected as <span className="font-medium text-charcoal">@{igStatus.username}</span></p>
            ) : (
              <p className="text-sm text-muted-text">Connect your Instagram to display a live feed on the website</p>
            )}
          </div>
        </div>
        {igStatus?.connected ? (
          <button
            onClick={disconnectInstagram}
            className="flex items-center gap-2 px-5 py-2.5 rounded-full border border-red-300 text-red-600 hover:bg-red-50 transition-colors text-sm font-medium"
            data-testid="ig-disconnect-btn"
          >
            <Unlink className="w-4 h-4" />
            Disconnect
          </button>
        ) : (
          <button
            onClick={connectInstagram}
            disabled={igLoading}
            className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-gradient-to-r from-purple-600 to-pink-500 text-white hover:opacity-90 transition-opacity text-sm font-medium"
            data-testid="ig-connect-btn"
          >
            <Link2 className="w-4 h-4" />
            {igLoading ? 'Connecting...' : 'Connect Instagram'}
          </button>
        )}
      </div>
    </div>
  );
}

export default InstagramPanel;
